/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";

class StickyToolsStore {
  @observable stickyToolVerbs;
  @observable stickyToolVerbsDetails;
  @observable isStickyToolPanelVisible;
  @observable stickyToolsAddOnPanel;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.stickyToolVerbs = {};
    this.stickyToolVerbsDetails = undefined;
    this.isStickyToolPanelVisible = true;
    this.stickyToolsAddOnPanel = null;
  }

  @action
  setStickyVerbs(value) {
    value.forEach(item => {
      const key = typeof item === "object" ? item.verbId : item;
      this.stickyToolVerbs[key] = item;
    });
  }

  @action
  setStickyToolVerbsDetail(value) {
    this.stickyToolVerbsDetails = value;
  }

  @action
  toggleStickyToolPanel() {
    this.isStickyToolPanelVisible = !this.isStickyToolPanelVisible;
  }

  @action
  updatePropertyForVerb(verb = "", property = "", value) {
    const stickyToolVerbsDetails = {
      ...this.stickyToolVerbsDetails,
      [verb]: {
        ...this.stickyToolVerbsDetails[verb],
        [property]: value
      }
    };
    this.setStickyToolVerbsDetail(stickyToolVerbsDetails);
  }

  @action
  registerStickyToolsAddOnPanel(callback) {
    this.stickyToolsAddOnPanel = callback;
  }
}

export { StickyToolsStore };
